import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export interface StackLabel {
    id: string;
    name: string;
    image: string | null;
    color: string;
    share: number;
    y: number;
}

interface StackLabelsProps {
    labels: readonly StackLabel[];
    right: number;
    top: number;
}

const LABEL_HEIGHT = 20;

export function StackLabels({ labels, right, top }: StackLabelsProps) {
    const theme = useTheme();

    return (
        <>
            {labels.map(label => (
                <Box
                    key={label.id}
                    data-testid={`stack-label-${label.id}`}
                    sx={{
                        position: 'absolute',
                        right,
                        top: top + label.y - LABEL_HEIGHT / 2,
                        height: LABEL_HEIGHT,
                        maxWidth: 240,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        pl: label.image ? '2px' : 1,
                        pr: 1,
                        borderRadius: `${LABEL_HEIGHT / 2}px`,
                        bgcolor: alpha(theme.palette.background.paper, 0.78),
                        border: 1,
                        borderColor: alpha(label.color, 0.55),
                        pointerEvents: 'none',
                        zIndex: 1,
                    }}
                >
                    {label.image ? (
                        <Box
                            component="img"
                            src={label.image}
                            alt=""
                            sx={{
                                width: 16,
                                height: 16,
                                borderRadius: '50%',
                                objectFit: 'cover',
                                flexShrink: 0,
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                bgcolor: label.color,
                                flexShrink: 0,
                            }}
                        />
                    )}
                    <Typography
                        sx={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: 'text.primary',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 0,
                        }}
                    >
                        {label.name}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '11px',
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            color: 'text.primary',
                            flexShrink: 0,
                        }}
                    >
                        {(label.share * 100).toFixed(0)}%
                    </Typography>
                </Box>
            ))}
        </>
    );
}
